
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-uae",
      function () {
        return require("private-next-pages/contact-uae/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-uae"])
      });
    }
  